import BaseModal from 'app/views/modals/base_modal';
import LoaderView from 'app/views/loader_view';

import tmpl from 'templates/loader_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,
  modalOptions: { keyboard: false },

  initialize() {
    this.addSubview('modal', '#loader_modal', new LoaderView({ showOnLoad: true, type: 'spin' }));
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/loader_modal.js